import { Grid } from '@mui/material';
import { useState } from 'react';
import { IJob } from 'wisestep-api';

import BulkEmail from '../../../../components/BulkEmail';
import BulkSmsDrawer from '../../../../components/BulkSms/BulkSmsDrawer';
import NoDataFoundCard from '../../../../components/noDataFoundCard';
import CandidateBulkSelectionBar from '../../../../features/candidates/components/candidateBulkSelectionBar';
import TalentPoolCandidateCard from '../../../../features/candidates/talentpool/components/candidateCard';
import { ITalentPoolSearch } from '../../../../features/candidates/talentpool/hooks/useTalentPoolSearch';
import {
  generateBackwardURL,
  getInteraction,
} from '../../../../features/candidates/utils/CandidateHelper';
import { PaginationCardLayout } from '../../components/paginationCardLayout';
import { JobTalentPoolDrawerType } from '../../utils/JobTalentPoolHelper';
import { Ipagination } from '../../utils/similarJobsHelper';
import {
  filteredNewSet,
  getSelectedCandidatesWithEmail,
  getSelectedCandidatesWithPhone,
} from '../../utils/sourcingHelper';

interface JobTalentPoolCandidateListingProps {
  data: ITalentPoolSearch;
  pagination: Ipagination;
  job: IJob;
  onPageChange: (e, val: number) => void;
}

const JobTalentPoolCandidateListing = ({
  data,
  pagination,
  job,
  onPageChange,
}: JobTalentPoolCandidateListingProps) => {
  const [drawerType, setDrawerType] = useState<JobTalentPoolDrawerType>('None');
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const toggleSelectedCandidate = (id: string) => {
    const newSet = filteredNewSet(id, selectedIds);
    setSelectedIds(newSet);
  };

  const selectAllCandidates = () => {
    const allIds = data.list
      .filter((candidate) => !candidate.isInDnc && candidate?.id)
      .map((candidate) => candidate.id as string);
    setSelectedIds(new Set(allIds));
  };

  const unselectAllCandidates = () => setSelectedIds(new Set());

  const isSelected = (candidateId: string) => selectedIds.has(candidateId);

  const handleCloseDrawer = () => {
    setDrawerType('None');
    unselectAllCandidates();
  };

  const candidateIdList = (data?.list ?? []).map((i) => i.id ?? '');

  return (
    <>
      {data.list.length ? (
        <PaginationCardLayout
          totalCount={data?.totalCandidates ?? 0}
          size={pagination.size}
          onPageChange={onPageChange}
          pageNumber={pagination.pageNumber}
        >
          {data.list.map((candidate, index) => (
            <Grid key={candidate?.id ?? index}>
              <TalentPoolCandidateCard
                job={job}
                candidate={candidate}
                isSelected={isSelected(candidate?.id ?? '')}
                checkBoxOnclick={() => toggleSelectedCandidate(candidate?.id ?? '')}
                openSingleEmail={() => {}}
                interaction={getInteraction(data.stageStatus, candidate.email)}
                onOpenShareIcon={() => {}}
                array={candidateIdList}
                backwardpathArray={[
                  { label: 'jobs', url: '/jobs' },
                  ...generateBackwardURL(job.title),
                ]}
              />
            </Grid>
          ))}
        </PaginationCardLayout>
      ) : (
        <NoDataFoundCard text="No Candidates Found" />
      )}

      {selectedIds.size !== 0 && (
        <CandidateBulkSelectionBar
          selectedCandidates={selectedIds.size}
          selectAllCandidates={selectAllCandidates}
          unselectAllCandidates={unselectAllCandidates}
          openBulkSms={() => setDrawerType('Sms')}
          openEmail={() => setDrawerType('Email')}
        />
      )}
      <BulkSmsDrawer
        open={drawerType === 'Sms'}
        handleClose={handleCloseDrawer}
        candidates={getSelectedCandidatesWithPhone(data?.list ?? [], selectedIds)}
        defaultJob={job}
      />

      {drawerType === 'Email' && (
        <BulkEmail
          ignoreDuplicateCheck={true}
          open={true}
          handleClose={handleCloseDrawer}
          candidates={getSelectedCandidatesWithEmail(data?.list ?? [], selectedIds)}
          drawer={true}
          defaultJob={job}
        />
      )}
    </>
  );
};

export default JobTalentPoolCandidateListing;
